import { createNewHandbookApi } from '@/api/handbookApi'
import { POSITION_PROPERTY_URL } from '@/api/handbook/position'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const TEST_URL = `${POSITION_PROPERTY_URL}/tests`

const errors = createHandbookResponseErrors('испытание', 'испытаний')

export const TestApi = createNewHandbookApi(TEST_URL, errors)
